import { Link, BrowserRouter, Route, Routes } from "react-router-dom";
import Home from "./componentes/home/home";
import InformeArticulos from "./componentes/articulos/informeArticulos";
import ArticuloDetail from "./componentes/articulos/articuloDetail";
import ArticuloNuevo from "./componentes/articulos/articuloNuevo";
import InformesClientes from "./componentes/clientes/informeClientes";
import ClienteDetail from "./componentes/clientes/clienteDetail";
import ClienteNuevo from "./componentes/clientes/clienteNuevo";
import InformesDocumentos from "./componentes/documentos/informeDocumentos";
import DocumentoDetail from "./componentes/documentos/documentoDetalle/documentoDetail";
import DocumentoNuevo from "./componentes/documentos/documentoNuevo/documentoNuevo";
import DocumentoMod from "./componentes/documentos/documentoModificacion/documentoMod";
import RotulosPedidos from "./componentes/documentos/rotulos/rotulosPedidos";
import NavBar from "./componentes/navBar/navBar";
import Calendario from "./componentes/calendario/calendario";
import Generales from "./componentes/ventas/general/generales";

function App() { 

  return (
    <BrowserRouter>
      <div className="">
        <NavBar />
      </div>
      <div className="md:ml-[150px]">
      <Routes>
        <Route exact path="/" element={<Home />}/>
        <Route exact path="/informesArticulos" element={<InformeArticulos />}/>
        <Route exact path="/articuloDetalle/:id" element={<ArticuloDetail />}/>
        <Route exact path="/articuloNuevo" element={<ArticuloNuevo />}/>
        <Route exact path="/informesClientes" element={<InformesClientes />}/>
        <Route exact path="/clienteDetalle/:id" element={<ClienteDetail />}/>
        <Route exact path="/clienteNuevo" element={<ClienteNuevo />}/>
        <Route exact path="/informesDocumentos" element={<InformesDocumentos />}/>
        <Route exact path="/documentoDetalle/:id" element={<DocumentoDetail />}/>
        <Route exact path="/documentoNuevo" element={<DocumentoNuevo />}/>
        <Route exact path="/documentoModificacion/:id" element={<DocumentoMod />}/>
        <Route exact path="/rotulos" element={<RotulosPedidos />}/>
        <Route exact path="/calendario" element={<Calendario />}/>
        <Route exact path="/ventasGenerales" element={<Generales />}/>
      </Routes>
      </div>
    </BrowserRouter>
  )

}

export default App
